import React from 'react';
import { toElement as scrollToElement } from '../../utils/scroll';
import './ScrollToNext.css';

const ScrollToNext = (props) => {

  const { pageSelector, arrow } = props;

  const scrollToNextElement = () => {
    const nextPage = document.querySelector(pageSelector);
    scrollToElement(nextPage);
  }

  return (
    <p className="scroll-to-next-arrow">
      {console.log(arrow)}
      <span className={arrow ? "arrow-down-blue" : "arrow-down"} onClick={scrollToNextElement} style={{ cursor: "pointer" }} />
    </p>
  );
};

export default ScrollToNext;